<template lang="pug">
  .faceGeoUpright( ref="area")
    .bg( ref="bg")
    .face_outer( :style="{ top: faceTop , transform: faceOuterTransform}")
      img.face( ref="face" :style="{opacity:faceOpacity, transform: faceTransform}" )
    canvas.polygon_canvas( v-show="mode === 'shapes'" ref="polygon_canvas" )
    .dots( v-show="mode!=='image'" ref="dots")
    .dot_annotations( v-show="mode !== 'image'" ref="dot_annotations" )
</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import $ from "jquery"
  import {fillPolygon} from 'src/services/FaceFeatureService/Utils'

  let MODE = {
    SHAPES:'shapes',
    IMAGE:'image',
    POINTS:'points',
  }

  export default {
    name: 'HeaderUi',
    components: {
    },
    data() {
      return {
        face_info:null,
        geoStraight:null,
        geoBasicStraight:null,
        inputImageSize:{
          w:1,
          h:1
        },
        outputImageSize:{
          w:1,
          h:1
        },

        drawArea:{
          w:1,
          h:1,
          origin:{
            x:0, y:0
          }
        }
      }
    },
    props: {
      mode: {
        type: String,
        default: MODE.SHAPES
      }
    },
    computed: {

      faceTop(){
        return (this.drawArea.h * this.drawArea.origin.y) + 'px'
      },

      faceOuterTransform(){
        if(!this.face_info){return ''}
        let  m =  FaceFeatureService.faceGeoModel
        let s = m.pixScaler * this.outputImageSize.h
        let r = this.face_info.faceBounds.angle
        return 'scale('+ s+','+ s +') rotate('+ r +'deg )'
      },

      faceOpacity(){
        return (this.mode===MODE.IMAGE) ? 1 : 0.5
      },

      faceTransform(){
        if(!this.face_info){return ''}
        let origin = this.face_info.midEyePoint || {x:0, y:0}
        let x = origin.x
        let y = origin.y
        return 'translate('+ -x+'px , '+ -y+'px)'
      }
    },

    mounted() {
      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },

    beforeDestroy() {},

    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      updateSize(){
        let origin = FaceFeatureService.faceGeoModel.draw_origin_unit
        this.drawArea.h = this.$refs.area.getBoundingClientRect().height
        this.drawArea.origin.y = origin.y
        this.setBGImage()
      },

      onFaceInfo(info){
        this.updateSize()
        setTimeout(()=>this.updateSize(), 100)

        this.img = FaceFeatureService.faceImage
        this.geoStraight = Object.assign({}, FaceFeatureService.faceGeoModel.geoStraight)
        this.geoBasicStraight = Object.assign({}, FaceFeatureService.faceGeoModel.geoBasicStraight)
        this.face_info = info
      },

      draw(){
        let drawArea = this.$refs.area
        let dots = this.$refs.dots
        let annotations = this.$refs.dot_annotations
        //clear dots
        if (!dots || !annotations){return}

        dots.innerHTML = ""
        annotations.innerHTML = ""

        let canvas = this.$refs.polygon_canvas

        if (!this.face_info){
          drawArea.style.opacity=0;
          return
        }

        drawArea.style.opacity=1;

        this.setBGImage()
        this.drawPolygons()
        this.drawPoints()
        this.drawPointsBasic()

        //console.info('setBGImage')


      },

      setBGImage(){
        let d = FaceFeatureService.faceImage
        if(!d || !d.imageData){return}

        let origin = FaceFeatureService.faceGeoModel.draw_origin_unit
        let drawArea = this.$refs.area
        let rt = drawArea.getBoundingClientRect()

        this.inputImageSize.w = d.width
        this.inputImageSize.h = d.height
        this.outputImageSize.w = rt.width
        this.outputImageSize.h = rt.height


        if( this.$refs["face"]) {
          this.$refs["face"].setAttribute("src", d.imageData)
        }
        console.info('setBGImage')

      },


      drawPolygons(){
        let canvas = this.$refs.polygon_canvas
        let drawArea = this.$refs.area

        let origin = FaceFeatureService.faceGeoModel.draw_origin_unit

        //double scale render
        let h = drawArea.getBoundingClientRect().height * 2;
        let w = drawArea.getBoundingClientRect().width * 2;
        let w2 = w*origin.x
        let h2 = h*origin.y

        canvas.width = w
        canvas.height = h
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0,0, w,h)

        var points = FaceFeatureService.faceGeoModel.faceShapePoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(255,0,0,0.5)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.lipTopPoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(0,255,0,0.5)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.lipBasePoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(0,255,0,0.5)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.nosePoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(0,0,255,0.5)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.eyeLeftPoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(255,255,0,0.8)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.eyeRightPoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(255,255,0,0.8)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.eyeBrowLeftPoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(0,0,0,0.6)','rgba(0,0,0,0.0)', 1, true);

        points = FaceFeatureService.faceGeoModel.eyeBrowRightPoints
        fillPolygon(canvas, {x:w2, y:h2} , h,  points,'rgba(0,0,0,0.6)','rgba(0,0,0,0.0)', 1, true);
      },

      drawPoints(){
        let drawArea = this.$refs.area
        let dots = this.$refs.dots
        let annotations = this.$refs.dot_annotations

        let origin = FaceFeatureService.faceGeoModel.draw_origin_unit

        let $dots= $(dots)
        drawArea.style.opacity=1;

        //getImageBounds from model
        let h = drawArea.getBoundingClientRect().height;
        let w = drawArea.getBoundingClientRect().width;
        //let hi = this.img.height;
        let s = h//1/(hi/hd)

        let w2 = w*origin.x
        let h2 = h*origin.y

        //draw dots
        let o = this.geoStraight;
        for(let k in o){
          let v = o[k];
          let message= k
          let x = w2 + (v.x*s)
          let y = h2 + (v.y*s)
          let $dot = $('<div />')
          $dot.addClass('draw_dot')
          $dots.append($dot)
          TweenLite.set($dot,{x:x, y:y})
        }
      },

      drawPointsBasic(){
        let drawArea = this.$refs.area
        let dots = this.$refs.dots
        let annotations = this.$refs.dot_annotations

        let origin = FaceFeatureService.faceGeoModel.draw_origin_unit

        let $dots= $(dots)

        //getImageBounds from model
        let h = drawArea.getBoundingClientRect().height;
        let w = drawArea.getBoundingClientRect().width;
        //let hi = this.img.height;
        let s = h//1/(hi/hd)

        let w2 = w*origin.x
        let h2 = h*origin.y

        //draw basic dots
        let o = this.geoBasicStraight;
        for(let k in o){
          let v = o[k];
          let message= k
          let x = w2 + (v.x*s)
          let y = h2 + (v.y*s)
          let $dot = $('<div />')
          $dot.addClass('draw_dot basic')
          $dots.append($dot)
          $dot.on('mouseenter', ()=>{console.log('geo:',message)})
          TweenLite.set($dot,{x:x, y:y})
        }
      },


  },

    watch: {
      face_info(){
        this.draw()
      }
    },
  }
</script>

<style lang="sass">
  @import "src/styles/common.sass"

  $width: 2480 * 0.125
  $height: 3508 * 0.125

  $pw: $width * 1px

  .faceGeoUpright
    z-index: 1
    position: absolute
    top: 0px
    //left: calc( 100% - #{$left} )
    width: $width * 1px
    height: $height * 1px
    overflow: hidden
    contain: layout
    opacity: 0
    pointer-events: none

    .face_outer
      transform-origin: 0px 0px
      position: absolute
      top: 50%
      left: 50%

    .face
      position: absolute
      top: 0
      left: 0
      opacity: 1



    .bg
      +full()
      background-color:  rgba(0,0,0,0.5)

    .polygon_canvas
      +full()
      display: block

    .draw_area
      +full()
      display: block



    .draw_rect
      +ab()
      border:  1px solid #00d700
      width: 30px
      height: 30px


    .dots
      +full()
      display: block

    .dot_annotations
      +full()
      display: block


    .dot_annotate
      +ab()
      background-color:  rgba(0,0,0,0.6)
      color:  white
      height:  3px
      line-height:  3px
      font-size:  2px


    .draw_dot
      +ab()
      background-color: #00ffff
      width: 1px
      height: 1px
      border-radius:  0.5px
      margin-left:  -0.5px
      margin-right:  -0.5px

      &.basic
        background-color: white
        width: 2px
        height: 2px
        border-radius:  1px
        margin-left:  -1px
        margin-right:  -1px



</style>
